import type { SelectionRound } from '@littlebooker/dal';

export type PhaseKey =
  | 'setup'
  | 'nominate_open'
  | 'nominate_closed'
  | 'shortlist'
  | 'allocate_open'
  | 'allocate_closed'
  | 'results';

export interface Phase {
  key: PhaseKey;
  stage: number; // index into RAIL_STAGES
  nominate?: SelectionRound;
  allocate?: SelectionRound;
}

export const RAIL_STAGES = [
  'Setup',
  'Round 1 · Nominate',
  'Shortlist',
  'Round 2 · Allocate',
  'Results',
];

const byOrdinal = (rounds: SelectionRound[]) => [...rounds].sort((a, b) => a.ordinal - b.ordinal);

/** Derive the current phase of a selection from its rounds. */
export function computePhase(rounds: SelectionRound[]): Phase {
  const sorted = byOrdinal(rounds);
  const nominate = sorted.find((r) => r.kind === 'nominate');
  const allocate = sorted.find((r) => r.kind === 'allocate');

  if (!nominate || nominate.state === 'draft') return { key: 'setup', stage: 0, nominate, allocate };
  if (nominate.state === 'open') return { key: 'nominate_open', stage: 1, nominate, allocate };
  if (nominate.state === 'closed') return { key: 'nominate_closed', stage: 1, nominate, allocate };
  // nominate revealed →
  if (!allocate || allocate.state === 'draft') return { key: 'shortlist', stage: 2, nominate, allocate };
  if (allocate.state === 'open') return { key: 'allocate_open', stage: 3, nominate, allocate };
  if (allocate.state === 'closed') return { key: 'allocate_closed', stage: 3, nominate, allocate };
  return { key: 'results', stage: 4, nominate, allocate };
}
